/* ============================================================
   SPARK — interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---- scroll progress ---- */
  var progress = document.getElementById('progress');
  function onScroll() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var pct = max > 0 ? (h.scrollTop || document.body.scrollTop) / max : 0;
    progress.style.width = (pct * 100) + '%';
    // sticky buy bar: show after hero
    var heroBottom = 620;
    var y = window.scrollY || h.scrollTop;
    var nearFooter = (max - y) < 120;
    if (y > heroBottom && !nearFooter) buybar.classList.add('show');
    else buybar.classList.remove('show');
  }

  /* ---- marquee: duplicate track for seamless loop ---- */
  var mq = document.getElementById('marquee');
  if (mq) { mq.innerHTML += mq.innerHTML; }

  /* ---- symptom chips ---- */
  var chips = document.getElementById('chips');
  var chipResp = document.getElementById('chip-resp');
  var lines = [
    "You're describing exactly who Spark was built for.",
    "That's the brain layer talking — not a willpower problem.",
    "Supplements can't reach this. A prescription can.",
    "This is the 'right tool for the actual problem' moment.",
  ];
  if (chips) {
    chips.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', String(!pressed));
      var count = chips.querySelectorAll('[aria-pressed="true"]').length;
      if (count > 0) {
        chipResp.style.display = 'block';
        var idx = Math.min(count - 1, lines.length - 1);
        chipResp.textContent = '→ ' + lines[idx] + (count >= 2 ? '  See if Spark fits ↓' : '');
      } else {
        chipResp.style.display = 'none';
      }
    });
  }

  /* ---- mechanism tabs ---- */
  var tabs = document.getElementById('tabs');
  if (tabs) {
    tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('.tab');
      if (!tab) return;
      tabs.querySelectorAll('.tab').forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
      });
      tab.setAttribute('aria-selected', 'true');
      ['p1', 'p2', 'p3'].forEach(function (id) {
        document.getElementById(id).hidden = true;
      });
      document.getElementById(tab.dataset.panel).hidden = false;
    });
  }

  /* ---- pricing: vertical plan selector + order bump ---- */
  var planList = document.getElementById('planList');
  var ctaPrice = document.querySelector('[data-cta-price]');
  var bump = document.getElementById('bump');
  var bumpCheck = document.getElementById('bumpCheck');
  var BUMP = 29; // daily foundation add-on, $/mo
  var planData = {
    monthly:   { n: 99,  sub: true,  base: '$99/mo' },
    quarterly: { n: 83,  sub: true,  base: '$83/mo' },
    onetime:   { n: 119, sub: false, base: '$119 one-time' }
  };
  function currentPlan() {
    var sel = planList && planList.querySelector('.plan.selected');
    return (sel && sel.dataset.plan) || 'quarterly';
  }
  function updateCta() {
    if (!ctaPrice) return;
    var p = planData[currentPlan()];
    var on = bumpCheck && bumpCheck.checked;
    var txt;
    if (!on) txt = p.base;
    else if (p.sub) txt = '$' + (p.n + BUMP) + '/mo';
    else txt = '$119 + $' + BUMP + '/mo';
    ctaPrice.textContent = txt;
    if (typeof syncCheckoutHref === 'function') syncCheckoutHref();
  }
  if (planList) {
    planList.addEventListener('click', function (e) {
      var plan = e.target.closest('.plan');
      if (!plan) return;
      planList.querySelectorAll('.plan').forEach(function (p) {
        p.classList.remove('selected');
        var r = p.querySelector('input'); if (r) r.checked = false;
      });
      plan.classList.add('selected');
      var radio = plan.querySelector('input'); if (radio) radio.checked = true;
      updateCta();
    });
  }
  if (bump) {
    bump.addEventListener('click', function (e) {
      e.preventDefault();
      bumpCheck.checked = !bumpCheck.checked;
      bump.classList.toggle('on', bumpCheck.checked);
      updateCta();
    });
  }
  updateCta();

  /* ---- Shopify checkout wiring ---- */
  var planCta = document.getElementById('planCta');
  var sparkPlans = {
    monthly: {
      fallback: '/cart/add?id=49309993337069&quantity=1&selling_plan=9595027693',
      items: [{ id: 49309993337069, quantity: 1, selling_plan: 9595027693 }]
    },
    quarterly: {
      fallback: '/cart/add?id=49436001763565&quantity=1&selling_plan=9595093229',
      items: [{ id: 49436001763565, quantity: 1, selling_plan: 9595093229 }]
    },
    onetime: {
      fallback: '/cart/add?id=49309993337069&quantity=1',
      items: [{ id: 49309993337069, quantity: 1 }]
    }
  };
  var foundationAddon = { id: 49334022701293, quantity: 1, selling_plan: 8333066477 };

  function selectedCheckout() {
    var key = currentPlan();
    var cfg = sparkPlans[key] || sparkPlans.quarterly;
    var items = cfg.items.map(function (item) { return Object.assign({}, item); });
    if (bumpCheck && bumpCheck.checked) items.push(Object.assign({}, foundationAddon));
    return { fallback: cfg.fallback, items: items };
  }

  function syncCheckoutHref() {
    if (!planCta) return;
    planCta.setAttribute('href', selectedCheckout().fallback);
  }

  function goToCheckout(e) {
    if (!planCta) return;
    e.preventDefault();
    var cfg = selectedCheckout();
    planCta.classList.add('is-loading');
    planCta.setAttribute('aria-busy', 'true');
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: cfg.items })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        window.location.href = cfg.fallback;
      });
  }

  if (planCta) {
    syncCheckoutHref();
    planCta.addEventListener('click', goToCheckout);
  }


  /* ---- exit-intent offer modal ---- */
  var exitOverlay = document.getElementById('exitOverlay');
  var EXIT_KEY = 'spark_exit_seen';
  var exitArmed = true;
  function showExit() {
    if (!exitOverlay || !exitArmed) return;
    if (sessionStorage.getItem(EXIT_KEY)) return;
    exitArmed = false;
    sessionStorage.setItem(EXIT_KEY, '1');
    exitOverlay.hidden = false;
  }
  function hideExit() { if (exitOverlay) exitOverlay.hidden = true; }
  if (exitOverlay) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 4) showExit();
    });
    var lastY = window.scrollY, engaged = false;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 1400) engaged = true;
      if (engaged && y < 300 && lastY - y > 40) showExit();
      lastY = y;
    }, { passive: true });
    document.getElementById('exitClose').addEventListener('click', hideExit);
    document.getElementById('exitDismiss').addEventListener('click', hideExit);
    document.getElementById('exitCta').addEventListener('click', hideExit);
    exitOverlay.addEventListener('click', function (e) {
      if (e.target === exitOverlay) hideExit();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideExit();
    });
  }

  /* ---- FAQ: single-open accordion ---- */
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        faqItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  /* ---- countdown (persistent-ish urgency) ---- */
  var buybar = document.getElementById('buybar');
  var cdEl = document.getElementById('countdown');
  var KEY = 'spark_offer_deadline';
  var deadline = parseInt(localStorage.getItem(KEY) || '0', 10);
  var now = Date.now();
  if (!deadline || deadline < now) {
    deadline = now + 15 * 60 * 1000; // 15 min
    localStorage.setItem(KEY, String(deadline));
  }
  function tick() {
    var left = Math.max(0, deadline - Date.now());
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    if (cdEl) {
      if (left <= 0) cdEl.textContent = '20% off — applied at checkout';
      else cdEl.textContent = '20% off ends in ' + m + ':' + (s < 10 ? '0' : '') + s;
    }
  }
  tick();
  setInterval(tick, 1000);

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
